<!--
 * @description: 科普践行
 * @Author: Jay
 * @Date: 2021-09-24 14:52:17
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-19 15:38:23
-->
<template>
  <div>
    <!-- 顶部Tab 切换 -->
    <TopTab></TopTab>
    <!-- 顶部 背景 标题 -->
    <bg-img-top
      :bgImg="$api + usData.image"
      EnTitle="The popular science practice"
      title="科普践行"
      v-if="usData != ''"
    ></bg-img-top>
    <!-- 页面内容 -->
    <div class="fix-width" v-if="usData != ''">
      <!-- 使命 标题 -->
      <center-title
        engTitle="written proposal"
        :title="usData.shiming.title"
      ></center-title>
      <div v-class="'animate__animated animate__fadeInUp'">
        <el-image
          class="mission-img"
          :src="$api + usData.shiming.value"
          fit="fill"
          :lazy="true"
        ></el-image>
      </div>
      <!-- 边距 -->
      <div class="margin-top margin-bottom"></div>
      <!-- 愿景 标题 -->
      <center-title
        engTitle="Popularization of science depends on practice"
        :title="usData.yuanjing.title"
      ></center-title>
      <!-- 愿景 内容 -->
      <vision-list-code
        :visionList="usData.yuanjing.article"
        v-if="usData.yuanjing.article != ''"
      ></vision-list-code>
      <div class="flex justify-center flex-sub" v-else>
        <el-result icon="info" title="内容为空" subTitle="请联系管理员及时更新">
        </el-result>
      </div>
      <!-- 边距 -->
      <div class="margin-top margin-bottom"></div>
      <!-- 科普 标题 -->
      <center-title
        engTitle="Advantage"
        :title="usData.kepu.title"
      ></center-title>
      <coupe-top-code :coupeList="usData.kepu.nav"></coupe-top-code>
    </div>
    <!-- 底部边距 -->
    <div class="margin-top margin-bottom"></div>
    <!-- 底部信息 -->
    <root-bottom></root-bottom>
  </div>
</template>

<script>
// 顶部Tab 切换
import TopTab from "@/components/tab/top-tab.vue";
// 底部信息
import rootBottom from "@/components/bottom/root-bottom.vue";
// 顶部 背景 标题
import bgImgTop from "@/components/tab/bg-img-top.vue";
// 居中标题
import centerTitle from "../../components/code/center-title.vue";
// 愿景 列表
import VisionListCode from "../../components/code/vision-list-code.vue";
// 科普Tab 内容
import CoupeTopCode from "../../components/code/coupe-top-code.vue";
import { aboutcoupe } from "../../api/api";
export default {
  name: "AboutCoupe",
  data() {
    return {
      //请求数据
      usData: [],
    };
  },
  components: {
    TopTab,
    rootBottom,
    bgImgTop,
    centerTitle,
    VisionListCode,
    CoupeTopCode,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 科普践行
      aboutcoupe().then((res) => {
        // console.log("1", res);
        this.usData = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 使命 图片
.mission-img {
  width: 100%;
  height: 480px;
}
</style>
